import { ActionTree } from "vuex";
import { AppState } from "./index";
import { RootState } from "../index";
import { User } from "./types";
import { AppMutation } from "../app/types";

export const actions: ActionTree<AppState, RootState> = {
  login({ commit }): any {
    commit(User.AUTHENTICATED, true);
  },
  logout({ commit }): any {
    commit(User.DO_LOGOUT);
  },
};
